import { render, staticRenderFns } from "./molecule.embroidery.imagesView.vue?vue&type=template&id=20a4636d"
import script from "./molecule.embroidery.imagesView.vue?vue&type=script&lang=ts"
export * from "./molecule.embroidery.imagesView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports